import { httpRequest } from './http.js';

export function apiGet(path, headers = {}) {
    return apiRequest('GET', path, headers);
}

export function apiPost(path, data = null, headers = {}) {
    return apiRequest('POST', path, headers, data);
}

export function apiPut(path, data = null, headers = {}) {
    return apiRequest('PUT', path, headers, data);
}

export function apiPatch(path, data = null, headers = {}) {
    return apiRequest('PATCH', path, headers, data);
}

export function apiDelete(path, headers = {}) {
    return apiRequest('DELETE', path, headers);
}

function apiRequest(method, path, headers = {}, data = null) {
    return new Promise((success, reject) => {
        httpRequest(
            method,
            '/rest/' + path,
            headers,
            data
        ).then(request => {
            success(getResponseData(request));
        }).catch(request => {
            reject(getResponseData(request));
        });
    });
}

function getResponseData(request) {
    return {
        status: request.status,
        data: parseResponseJson(request)
    }
}

export function parseResponseJson(request) {

    if (request.status === 204) {
        // Don't try to parse to JSON in this case as
        // a 204 request does not include a message-body.
        // https://restfulapi.net/http-status-204-no-content/
        return {}
    }

    try {
        return JSON.parse(request.responseText);
    } catch (e) {
        console.debug("Response data is not valid JSON", request.responseText);
        return {}
    }
}
